import { render, staticRenderFns } from "./sendGroup.vue?vue&type=template&id=0099d2a9&"
import script from "./sendGroup.vue?vue&type=script&lang=js&"
export * from "./sendGroup.vue?vue&type=script&lang=js&"
import style0 from "./sendGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports